
import Vue from 'vue'

const getDefaultState = () => {
    return {
        anexo: {
            id: 0,
            chave: 0,
            nome: "",
            tipoDocumento: 0
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async List() {

        try {
            const result = await Vue.prototype.$spTechApi.get("anexos/list",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listAnexo = result.data.result;

                return listAnexo;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Erro ao listar o anexo: [${ex}]`
            };
        }
    },

    async GetById(_, id) {

        try {
            const result = await Vue.prototype.$spTechApi.get(`anexos/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Erro ao obter o anexo`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Erro ao obter o anexo: [${ex}]`
            };
        }
    },

    async GetAll(_, { tipoAnexo, chave }) {

        try {

            const result = await Vue.prototype.$spTechApi.get(`anexos/get-all/${tipoAnexo}/${chave}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listAnexo = result.data.result;

                return listAnexo;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Error to get list anexos: [${ex}]`
            };
        }
    },

    async GetAllByDocument(_, { typeAnexo, tipoDocumento, chave }) {

        try {

            const result = await Vue.prototype.$spTechApi.get(`anexos/get-all-by-document/${typeAnexo}/${tipoDocumento}/${chave}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listAnexo = result.data.result;

                return listAnexo;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Error to get list anexos: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, anexoFileRequest) {

        try {

            const result = await Vue.prototype.$spTechApi.post(`anexos/create-update`, anexoFileRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {

                let msg = "Registro criado com sucesso";

                return {
                    success: true,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: "Erro ao criar/alterar o registro!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Erro ao criar/alterar o registro: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Erro ao criar/alterar o registro: [${error}]`
                };
            }
        }
    },

    async Delete(_, id) {

        try {
            const result = await Vue.prototype.$spTechApi.delete(`anexos/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                return {
                    success: true,
                    message: "Registro excluído com sucesso!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Erro ao excluir o registro: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Erro ao excluir o registro: [${error}]`
                };
            }
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.anexo, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.anexo;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
